export const MAX_IMAGE_FILE_BYTES = 5 * 1024 * 1024;

export const MAX_GALLERY_IMAGES = 5;

export const ALLOWED_RASTER_MIME_TYPES = ["image/png", "image/jpeg", "image/jpg"];

export const ALLOWED_RASTER_EXTENSIONS = [".png", ".jpg", ".jpeg"];

export const ALLOWED_SVG_MIME_TYPES = ["image/svg+xml"];

export const ALLOWED_SVG_EXTENSIONS = [".svg"];
